export const IMAGES = {
    AVATAR_DEFAULT: 'assets/images/avatars/user.png',
    LOGO: 'assets/images/Logo/logo.png',
    LOGO_DARK: "/assets/images/Logo/logo-dark.png",
    WHITE_BACKGROUND: '/assets/images/bg/white-bg.png',
    HEADER_BACKGROUND: '/assets/images/bg/getchkdbg.png',
    ASSETMANAGEMENT: "/assets/images/icons/assetmanagement.png",
    HCM: '/assets/images/icons/hcm.png',
    JUNIPER: '/assets/images/icons/jupiter.png',
    SALESFORCE: '/assets/images/icons/salesforce.png',
    SPLUNK: '/assets/images/icons/splunk.png',
    ICONS: {
        HOME: 'assets/icons/home.svg',
        SETTINGS: 'assets/icons/settings.svg',
    },
};
